import { yupResolver } from '@hookform/resolvers/yup';
import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import React from 'react';
import { useForm } from 'react-hook-form';
import { defaultInitialValues } from './constants';
import { LoginFormData, loginFormSchema } from './formSchema';

type LoginFormImplParams = {
  initialValues?: Partial<LoginFormData>;
  isRelogin?: boolean;
};

export const useLoginFormImpl = ({
  initialValues,
  isRelogin = false,
}: LoginFormImplParams) => {
  const {
    control,
    watch,
    trigger,
    handleSubmit: formHandleSubmit,
  } = useForm<LoginFormData>({
    mode: 'onBlur',
    defaultValues: { ...defaultInitialValues, ...initialValues },
    resolver: yupResolver(loginFormSchema({ isRelogin })),
  });

  const handleSubmit = (onSubmit: (data: LoginFormData) => void) => {
    return (e: React.FormEvent<HTMLFormElement>) => {
      AnalyticsManager.instance().track(AnalyticsEvent.click_login, {
        from: isRelogin ? 'pop_up' : 'login',
      });
      formHandleSubmit(onSubmit)(e);
    };
  };

  return { control, watch, trigger, handleSubmit };
};
